import { mount2faAuthentication } from '~/authentication/mount_2fa';
import { initPasswordInput } from '~/authentication/password';

mount2faAuthentication();
initPasswordInput();
